/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add extra information',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  if (productItem) {
                     var checkTag = productData.tags.includes("pfs:label-Final Sale"); 
                    if(checkTag){
                      var saleLabel =  productItem.querySelector('.boost-sd__product-label--sale')
                        saleLabel.style.setProperty("display", "none", "important");
                    }
                    const productPriceContent = productItem.querySelector(".boost-sd__product-price-content");
                    if (productData.percent_sale_min > 0 && productPriceContent) {
                      const saleText = '<span class="boost-sd-custom-sale-text">Compare at</span>';
                      if (!productPriceContent.querySelector(".boost-sd-custom-sale-text") && productPriceContent.firstChild) {
                        productPriceContent.firstChild.insertAdjacentHTML('afterend', saleText);
                      }
                    }

                    if (productData?.percent_sale_min > 0) {
                        const percentSaleHtml = `<span class="boost-sd-percent-sale-info">Save ${productData.percent_sale_min}%</span>`;
                        if (!productItem.querySelector('.boost-sd-percent-sale-info')) {
                           productItem.querySelector('.boost-sd__product-price-wrapper').insertAdjacentHTML('beforeend', percentSaleHtml);
                        }
                     }
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
  registry.useModulePlugin("RecommendationAPI", {
    name: "Recommendation API before call",
    apply(builder) {
      builder.on("beforeMethodCall", "get", (payload) => {
        // Custom code goes here
        const tag = "pfs-not-on-sale";
        payload.args[1].tags = [tag]; // string array
        // console.log(payload)
      })
    },
  });
});


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductImage', {
    name: 'Modify Component ProductImage',
    enabled: true,
    apply: () => ({
      props: (props, element) => {
        // console.log(props)

        try {
          // Update feature image
          if(props.originalSize && boostSDAppConfig.generalSettings.collection_id === 13509885980) {
            let images = props.originalSize
            const newImages = [];
          for (const img of images) {
          	if (img.src.indexOf('/files/plus_size_') !== -1) {
              // console.log('got it', img)
            	props.images[0] = img.src;
            } 
            
            if (img.src.indexOf('_plus_size_') !== -1){
              if (props.images[1]) {
                props.images[1] = img.src
              }
            }
          }
          }
          
        } catch (error) {
          console.warn(error)
        }
  
        return props;
      },
    }),
  });
}]);